export const en = {
    'banner-id': '№ {id}'
};
